// eslint-disable-next-line max-classes-per-file
import { NewRelicPlusPlugin, NewRelicPlusPublisher, NewRelicPublisher } from '@cof/stratum';
import { NewRelicCustomAttribute } from '@cof/refi-web-sdk/dist/utils/stratum';
import { REFI_WEB_UI_CONST } from '../constants/constants.js';

export const applyPluginVarsAsAttributes = (interaction, vars) => {
  for (const [k, v] of Object.entries(vars)) {
    interaction.setAttribute(k, v);
  }
};

export class FtNewRelicPublisher extends NewRelicPublisher {
  // Override
  getDefaultInteraction(event) {
    const interaction = super.getDefaultInteraction(event);
    applyPluginVarsAsAttributes(interaction, event.plugins[REFI_WEB_UI_CONST.NEW_RELIC_PLUGIN_NAME].vars);
    return interaction;
  }
}

export class FtNewRelicPlusPublisher extends NewRelicPlusPublisher {
  // Override
  getDefaultInteraction(event) {
    const interaction = super.getDefaultInteraction(event);
    applyPluginVarsAsAttributes(interaction, event.plugins[REFI_WEB_UI_CONST.NEW_RELIC_PLUGIN_NAME].vars);
    return interaction;
  }
}

export const RefiNewRelicPlugin = () => {
  const plugin = NewRelicPlusPlugin();

  const vars = Object.values(NewRelicCustomAttribute).reduce((obj, key) => {
    // eslint-disable-next-line no-param-reassign
    obj[key] = null;
    return obj;
  }, {});

  return {
    name: REFI_WEB_UI_CONST.NEW_RELIC_PLUGIN_NAME,
    eventTypes: plugin.eventTypes,
    publishers: [new FtNewRelicPublisher(), new FtNewRelicPlusPublisher()],
    vars,
  };
};
